import { createFileRoute } from "@tanstack/react-router";
import type { FermentationGroupId } from "@brewbase/db/types";
import { GeneralSection } from "@/features/fermentation-journal/components/planning";

export const Route = createFileRoute(
  "/fermentations/$group_id/planning/general",
)({
  component: GeneralPage,
});

function GeneralPage() {
  const { group_id } = Route.useParams();
  const groupId = Number(group_id) as FermentationGroupId;

  return (
    <div className="max-w-4xl">
      <GeneralSection groupId={groupId} />
    </div>
  );
}

